var __jsx = React.createElement;
import React, { useEffect, useState } from 'react';
export var HeaderContext = /*#__PURE__*/React.createContext();
var HeaderStateProvider = function HeaderStateProvider(_ref) {
  var children = _ref.children,
    initialData = _ref.initialData;
  return __jsx(HeaderContext.Provider, {
    value: {
      handleMobileMenuToggle: initialData === null || initialData === void 0 ? void 0 : initialData.handleMobileMenuToggle
    }
  }, children);
};
export default HeaderStateProvider;